export const FINAL_SUBMISSION_SUCCESS_COPY = {
  title: 'Count submitted successfully',
  paragraphs: [
    'Your count has been submitted to the manager successfully.',
    'Press OK to refresh the page and update your count status.'
  ],
  confirmLabel: 'OK'
};

export function handleFinalSubmissionSuccessRefresh() {
  if (typeof window !== 'undefined' && typeof window.location.reload === 'function') {
    window.location.reload();
  }
}
